import { ChainLayer } from '@cronos-app/sdk';
import { getAccessToken } from './authentication/getAccessToken';
import { getServerEndpoint } from './endpoints/serverEndpoints';
export const server = {
    get: (endpointConfig, options) => fetchAtAgentfun(endpointConfig, { ...options, method: 'GET' }),
    post: (endpointConfig, options) => fetchAtAgentfun(endpointConfig, { ...options, method: 'POST' }),
    put: (endpointConfig, options) => fetchAtAgentfun(endpointConfig, { ...options, method: 'PUT' }),
};
export const prepareRequestUrl = (endpointConfig) => {
    let url = getServerEndpoint(endpointConfig.endpoint);
    if (endpointConfig.queryParams || endpointConfig.chainLayer) {
        const queryParams = new URLSearchParams(endpointConfig.queryParams ?? '');
        if (endpointConfig.chainLayer === ChainLayer.L2)
            queryParams.set('chain', 'cronoszk');
        else if (endpointConfig.chainLayer === ChainLayer.CronosEvm)
            queryParams.set('chain', 'cronos');
        url = `${url}?${queryParams.toString()}`;
    }
    return url;
};
export const prepareRequestConfig = async (endpointConfig, options) => {
    const { walletAddress, needAuthentication, ...rest } = options;
    const requestInit = {
        ...rest,
    };
    // add wallet address to the header if it is provided
    if (walletAddress) {
        requestInit.headers = {
            ...requestInit.headers,
            'wallet-address': walletAddress.toLowerCase(),
        };
    }
    // add bearer authorization token to the header if need it
    if (needAuthentication) {
        const tokenData = await getAccessToken(walletAddress);
        if (!tokenData.success)
            throw new Error('no valid cookie');
        requestInit.headers = {
            ...requestInit.headers,
            Authorization: `Bearer ${tokenData.token}`,
        };
    }
    requestInit.headers = {
        ...requestInit.headers,
    };
    const url = prepareRequestUrl(endpointConfig);
    return {
        url,
        requestInit,
    };
};
const fetchAtAgentfun = async (endpointConfig, options) => {
    const { url, requestInit } = await prepareRequestConfig(endpointConfig, options);
    return fetch(url, requestInit);
};
